import * as React from 'react';

function SvgProcessPending(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity={0.3}>
        <mask
          id="process-pending_svg__a"
          maskUnits="userSpaceOnUse"
          x={6}
          y={6}
          width={4}
          height={4}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 10a2 2 0 100-4 2 2 0 000 4z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#process-pending_svg__a)">
          <path fill="#748CAD" d="M0 0h16v16H0z" />
        </g>
      </g>
    </svg>
  );
}

export default SvgProcessPending;
